import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { Gender } from '~/shared';
import avatar from '../../assets/images/avatar.png';
import logoState from '../../assets/images/logo_state.png';
import sign from '../../assets/images/sign.svg';
import {
	StyledColumn,
	StyledContainer,
	StyledDecBottom,
	StyledDecUp,
	StyledDividers,
	StyledHead,
	StyledHeadText,
	StyledMainContainer,
	StyledRightContainer,
	StyledSignContainer,
	StyledStateName,
	StyledValue,
} from './Passport.styled';

const Passport = () => {
	const nickname = useObservable(rage.player.getNickname());
	const playerGender = useObservable(rage.player.getPlayerGender());
	const accountId = useObservable(rage.player.getAccountId());
	const registrationDate = useObservable(
		rage.player.getPlayerRegistrationDate(),
	);

	return (
		<StyledContainer>
			<StyledHead>
				<img src={logoState} />
				<StyledHeadText>
					<StyledStateName />
					<Text
						style={{
							fontSize: 12,
							fontWeight: 500,
							color: '#000000',
							opacity: 0.5,
						}}
					>
						ПАСПОРТ ГРАЖДАНИНА USA
					</Text>
				</StyledHeadText>
			</StyledHead>
			<StyledDividers>
				<Divider $direction="H" $color="#FFFFFF" style={{ opacity: 0.25 }} />
				<Divider $direction="H" $color="#000000" style={{ opacity: 0.1 }} />
			</StyledDividers>
			<StyledMainContainer>
				<StyledDecUp />
				<img src={avatar} />
				<StyledRightContainer>
					<StyledColumn>
						<StyledValue>
							<Text>Имя Фамилия:</Text>
							<Text>{nickname}</Text>
						</StyledValue>
						<StyledValue>
							<Text>Пол:</Text>
							<Text>
								{playerGender === Gender.MALE ? 'Мужской' : 'Женский'}
							</Text>
						</StyledValue>
						<StyledValue>
							<Text>Место жительства:</Text>
							<Text>ул. Джорда Флойда</Text>
						</StyledValue>
						<StyledValue>
							<Text>Ваш UID:</Text>
							<Text>{accountId}</Text>
						</StyledValue>
					</StyledColumn>
					<StyledColumn>
						<StyledValue style={{ alignItems: 'flex-end' }}>
							<Text>Дата выдачи:</Text>
							<Text>
								{new Date(registrationDate).toLocaleDateString('ru-RU', {
									day: '2-digit',
									month: '2-digit',
									year: '2-digit',
									timeZone: 'Europe/Moscow',
								})}
							</Text>
						</StyledValue>
						<StyledSignContainer>
							<Text>Подпись:</Text>
							<img src={sign} />
						</StyledSignContainer>
					</StyledColumn>
				</StyledRightContainer>
			</StyledMainContainer>
			<StyledDecBottom />
		</StyledContainer>
	);
};

export { Passport };
